import React, { useRef, useEffect, useState } from "react";
import styles from "./Partners.module.css";
import useHeroAPI from "../../../api/useHeroAPI";
import { Image } from "react-bootstrap";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AppSkeleton from "../../AppSkeleton/AppSkeleton";
interface PartnersProps {
  code: "TYRE" | "BATTERY";
}

export default function Partners({ code }: PartnersProps) {
  const { predefinedFunc } = useHeroAPI();
  const navigate = useNavigate();

  const basePath = process.env.REACT_APP_BASE_PATH || "/";
  const [tyreBrandImgs, setTyreBrandImgs] = useState([]) as any;
  const [isBrandLoading, setIsBrandLoading] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [productType, setProductType] = useState<any>(null);
  const [defaultCategory, setDefaultCategory] = useState<any>(null);
  const [loader, setLoader] = useState(false);
  const logoWrapperRef = useRef<HTMLDivElement>(null);
  const visibleBrands = [
    ...tyreBrandImgs.slice(startIndex),
    ...tyreBrandImgs.slice(0, startIndex),
  ];
  const fetchProductType = async (code: string) => {
    const payload = { entity_type: "PRODUCT-TYPE", code };
    const response = await predefinedFunc(payload);
    if (response?.status === 200) {
      setProductType(response?.data?.data?.[0] ?? null);
    }
  };

  const fetchDefaultCategory = async () => {
    const payload = { entity_type: "CATEGORY" };
    const response = await predefinedFunc(payload);
    if (response?.status === 200) {
      const types = response?.data?.data || [];
      const defaultType =
        types.find(
          (type: any) =>
            type?.code === "TWO WHEELER" ||
            type?.name?.toLowerCase().includes("two"),
        ) || types[0];
      setDefaultCategory(defaultType || null);
    }
  };

  // const fetchPopularBrands = async (product_type?: any) => {
  const fetchPopularBrands = async () => {
    setIsBrandLoading(true);
    // const payload = {
    //   entity_type: "BRAND",
    //   parent_id: "8151",
    //   user_id: null,
    // };
    const payload = {
      entity_type: "BRAND",
      parent_id: productType?.predefined_id,
      user_id: null,
    };
    try {
      const response = await predefinedFunc(payload);
      if (response.status === 200) {
        setTyreBrandImgs(response.data.data);
      } else {
        setTyreBrandImgs([]);
      }
    } finally {
      setIsBrandLoading(false);
    }
  };
  // useEffect(() => {
  //   const load = async () => {
  //     // await fetchProductType("TYRE");
  //     await fetchProductType(code);
  //     await fetchDefaultCategory();
  //   };

  //   load();
  // }, []);
  useEffect(() => {
    const load = async () => {
      await fetchProductType(code);
      await fetchDefaultCategory();
    };

    load();
  }, [code]);
  useEffect(() => {
    if (productType?.predefined_id) {
      fetchPopularBrands();
    }
  }, [productType]);
  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % tyreBrandImgs.length);
  };

  const handlePrev = () => {
    setStartIndex(
      (prev) => (prev - 1 + tyreBrandImgs.length) % tyreBrandImgs.length,
    );
  };
  const handleBrandClick = (brand: any) => {
    if (!brand?.predefined_id) return;

    navigate(`${basePath}products`, {
      state: {
        selectedBrand: brand,
        category_ids: defaultCategory?.predefined_id,
        productType: productType?.predefined_id,
        code,
      },
    });
  };
  return (
    <section className={styles.partnersSection}>
      <div className={styles.container}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 className={styles.title}>Popular Brands</h3>
          <div className={styles.sliderControls}>
            <button
              onClick={handlePrev}
              className={styles.sliderBtn}
              aria-label="Previous Testimonials"
            >
              <MdChevronLeft size={24} />
            </button>
            <button
              onClick={handleNext}
              className={styles.sliderBtn}
              aria-label="Next Testimonials"
            >
              <MdChevronRight size={24} />
            </button>
          </div>
        </div>
        {/* <div className={styles.logoGrid}>
          {tyreBrandImgs.map((brand: any, idx: number) => (
            <div
              key={idx}
              className={styles.brandLogo}
              style={{ display: `${!brand?.url ? "none" : "block"}` }}
            >
              <Image src={brand?.url} alt={brand?.name} />
            </div>
          ))}
        </div> */}
        {/* <div className={styles.testimonialsHeader}>
          
        </div> */}
        {/* <div className={styles.logoWrapper}> */}
        <div className={styles.logoWrapper} ref={logoWrapperRef}>
          <div className={styles.logoGrid}>
            {isBrandLoading ? (
              <AppSkeleton
                count={5}
                width="150px"
                height="100px"
                borderRadius="12px"
                containerClassName="popular-brands-skeleton-grid"
                className="popular-brands-skeleton-item"
              />
            ) : (
              visibleBrands.map((brand: any, idx: number) => (
                <div
                  key={idx}
                  className={styles.brandLogo}
                  style={{ display: !brand?.url ? "none" : "flex" }}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleBrandClick(brand)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      handleBrandClick(brand);
                    }
                  }}
                >
                  <Image src={brand?.url} alt={brand?.name} />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
